import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'helpers/apolloClient';
import { GET_TEAM_BY_SUBDOMAIN } from 'graphql/queries';
import { getSubdomain } from 'helpers/global';

export const getTeam = createAsyncThunk('whiteLabel/getTeam', async () => {
  const { data } = await client.query({
    query: GET_TEAM_BY_SUBDOMAIN,
    variables: { subdomain: getSubdomain() || undefined }
  });

  return data.getTeamBySubdomain;
});

export const whiteLabelSlice = createSlice({
  name: 'whiteLabel',
  initialState: {
    isLoadingWhiteLabel: true,
    whiteLabelTeam: undefined,
    isWhiteLabelCompany: false
  },
  extraReducers: (builder) => {
    builder.addCase(getTeam.pending, (state) => {
      state.isLoadingWhiteLabel = true;
    });

    builder.addCase(getTeam.fulfilled, (state, action) => {
      state.whiteLabelTeam = action.payload;

      state.isWhiteLabelCompany = action.payload?.whiteLabelAccount;

      state.isLoadingWhiteLabel = false;
    });
  }
});

export default whiteLabelSlice.reducer;
